module.exports = __webpack_public_path__ + "static/media/test13.cd076653.jpeg";